import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@insurancemenu/imenu-components-lib';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { UserStatus, UserType } from 'types/userService';
import { toJS } from 'mobx';
import { inviteToSelfEnroll } from 'api/operations/userService';
import { toastManager } from '@insurancemenu/imenu-components-lib/dist/components/Toast/toastManager';
import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { createStyles } from './styles';

const InviteAdmin: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();
  const classes = createStyles();

  const {
    groupSidebarStore: {
      group: { contactInfo },
    },
    additionalAccessStore: { groupEmployers, getEmployersForGroup },
  } = useRootStore();

  const convertedGroupEmployers = groupEmployers?.map((employer) => toJS(employer)).slice();
  const necessaryFieldsForInvitation: string[] = ['firstName', 'lastName', 'primaryEmail'];

  const isInviteButtonAvailable = necessaryFieldsForInvitation.every(
    (field) => contactInfo[field as keyof typeof contactInfo],
  );
  const isAdminInvited =
    convertedGroupEmployers.find(({ email }) => email === contactInfo.primaryEmail)?.status === UserStatus.INVITED;

  const toastMessage = isAdminInvited
    ? 'Group admin was successfully reinvited'
    : 'Group admin was successfully invited';

  const inviteAdmin = async (): Promise<void> => {
    const { firstName = '', lastName = '', primaryEmail = '', title = '' } = contactInfo;
    const userInfo = {
      firstName,
      lastName,
      email: primaryEmail,
      title,
      groupId,
      userType: 'EMPLOYER' as UserType,
    };
    const newEmployers = await inviteToSelfEnroll([userInfo]);

    if (newEmployers.length) {
      toastManager.addToast(toastMessage, ToastColorTypes.SUCCESS);
      // needed to get an updated list of employers
      setTimeout(() => {
        void getEmployersForGroup(groupId);
      }, 2500);
    }
  };

  return (
    <>
      <div className={classes.categoryWrapper}>
        <Button
          size="medium"
          color="primary"
          leftIconProp={<Add />}
          disabled={!isInviteButtonAvailable}
          onClick={inviteAdmin}
          id="invite-admin-button"
        >
          {isAdminInvited ? 'Reinvite Group admin' : 'Invite Group admin'}
        </Button>
        {!isInviteButtonAvailable && (
          <p className={classes.errorDisclaimer} id="invite-error-message">
            Full name and email are required to invite admin
          </p>
        )}
      </div>
    </>
  );
});

export default InviteAdmin;
